/* BOXO – oversetter Koala-appens engelske tekster til norsk.
   Legg til flere linjer i listen under ved behov (engelsk: norsk). */
(function () {
  var oversettelser = {
    "Change": "Endre",
    "Choose product": "Velg produkt",
    "Select product": "Velg produkt",
    "Selected": "Valgt"
  };

  function oversett(rot) {
    var walker = document.createTreeWalker(rot, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue.trim();
      if (oversettelser[t]) {
        node.nodeValue = node.nodeValue.replace(t, oversettelser[t]);
      }
    }
  }

  function kjor() {
    document.querySelectorAll('[class*="koala-deal"]').forEach(oversett);
  }

  kjor();
  new MutationObserver(kjor).observe(document.body, { childList: true, subtree: true });
})();